import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class FormView extends Page{
    constructor(){
        super({
            id : 'form',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}